/**
 * Calculates the bounding box coordinates from a GeoJSON object
 * @param {Object|string} geoJson - GeoJSON object or string
 * @returns {Array|null} Array of coordinate pairs [[minLat, minLng], [maxLat, maxLng]] or null if invalid
 */
export const getBoundsFromGeoJson = (geoJson) => {
    if (!geoJson) return null;
    
    let processedGeoJson = geoJson;
    if (typeof geoJson === 'string') {
        try {
            processedGeoJson = JSON.parse(geoJson);
        } catch (e) {
            console.error('Failed to parse GeoJSON string:', e);
            return null;
        }
    }

    let coordinates;
    if (processedGeoJson.type === 'Feature' && processedGeoJson.geometry) {
        coordinates = processedGeoJson.geometry.coordinates;
    } else if (processedGeoJson.type === 'Polygon' || processedGeoJson.type === 'MultiPolygon') {
        coordinates = processedGeoJson.coordinates;
    } else if (processedGeoJson.coordinates) {
        coordinates = processedGeoJson.coordinates;
    } else {
        return null;
    }

    if (!coordinates || !coordinates.length) return null;

    let minLat = Infinity, maxLat = -Infinity;
    let minLng = Infinity, maxLng = -Infinity;

    const processCoordArray = (coordArray) => {
        if (!Array.isArray(coordArray)) return;
        
        if (coordArray.length === 2 && typeof coordArray[0] === 'number') {
            const [lng, lat] = coordArray;
            minLat = Math.min(minLat, lat);
            maxLat = Math.max(maxLat, lat);
            minLng = Math.min(minLng, lng);
            maxLng = Math.max(maxLng, lng);
            return;
        }

        coordArray.forEach(item => processCoordArray(item));
    };

    processCoordArray(coordinates);

    if (isNaN(minLat) || isNaN(maxLat) || isNaN(minLng) || isNaN(maxLng)) {
        return null;
    }

    return [[minLat, minLng], [maxLat, maxLng]];
};
